import { Component } from '@angular/core';
import { DeviceUuidService } from '../auth/login/services/device-uuid.service';

@Component({
    selector: 'app-status',
    templateUrl: './status.component.html',
    styleUrls: ['./status.component.scss'],
    standalone: false
})
export class StatusComponent {

    code: string;
    response: string;

    constructor(
        private deviceUuidService: DeviceUuidService,
    ) {
        this.deviceUuidService.getDeviceUUID()
            .subscribe(result => this.code = result);
    }

}
